import React, {useState, useEffect} from 'react';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

function FindRoll(){

  const [Rolls, SetRolls] = useState([]);
  useEffect(() => {
    const fetchRolls = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/stocks/stock_rolls.json');
      const jsonresult = await result.json()
      SetRolls(jsonresult)
    }
    fetchRolls();
  }, []);

  const [Roll, SetRoll] = useState([]);

  const handleFindRoll = () => {
    let roll_id = document.getElementById('FIND_ROLL_ID').value;

    if (Rolls.some(roll => roll.roll_id === roll_id)) {

      let found_roll = (Rolls.find(roll => roll.roll_id === roll_id));
      SetRoll(found_roll);
    };

  }

  return (
    <Form>
      <div className="row p-1">
          <div className="col"><h1>Find Roll</h1></div>
      </div>
      <FloatingLabel id="floating_ROLL_ID_label" label="Roll ID" className="mb-3">
        <Form.Control
          className="mb-1"
          type='string'
          id="FIND_ROLL_ID"
          onChange={handleFindRoll}
        />
      </FloatingLabel>
      <div className="row p-1">
        <h2>Roll Info</h2>
      </div>
      <div className="row p-1">
        <FloatingLabel id="floating_Selected_Roll_ID_label" label="Roll ID" className="mb-3">
          <Form.Control
            readOnly
            value={Roll.id}
            defaultValue={0}
          />
        </FloatingLabel>
      </div>
      <div className="row p-1">
        <FloatingLabel id="floating_Selected_Roll_ID_label" label="Current Roll Length" className="mb-3">
          <Form.Control
            readOnly
            value={Roll.length}
            type='number'
            defaultValue={0}
          />
        </FloatingLabel>
      </div>
      <div className="row p-1">
        <FloatingLabel id="floating_Selected_Roll_ID_label" label="Current Roll Width" className="mb-3">
          <Form.Control
            readOnly
            value={Roll.width}
            type='number'
            defaultValue={0}
          />
        </FloatingLabel>
      </div>
      <div className="row p-1">
        <FloatingLabel id="floating_Selected_Roll_ID_label" label="Roll Created" className="mb-3">
          <Form.Control
            readOnly
            value={Roll.created_at}
          />
        </FloatingLabel>
      </div>
      <div className="row p-1">
        <FloatingLabel id="floating_Selected_Roll_ID_label" label="Roll Last Updated" className="mb-3">
          <Form.Control
            readOnly
            value={Roll.updated_at}
          />
        </FloatingLabel>
      </div>
    </Form>
  );
}

export default FindRoll;
